import { createSlice } from "@reduxjs/toolkit";
import { updateClaimInvoice } from "../../reducer/claimsinvoice/claimsinvoiceReducer";

const initialState = {
  data: {},
  isLoading: false,
  error: null,
};

const updateClaimInvoiceSlice = createSlice({
  name: "updateClaimInvoice",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(updateClaimInvoice.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(updateClaimInvoice.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload?.data || {};
      })
      .addCase(updateClaimInvoice.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload || action.error.message;
      });
  },
});

export default updateClaimInvoiceSlice.reducer;
